var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSmile = function SvgSmile(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#smile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374151",
    fillRule: "evenodd",
    d: "M21.484 12.55a8.497 8.497 0 1 1-16.993 0 8.497 8.497 0 0 1 16.993 0Zm1.5 0c0 5.521-4.476 9.997-9.997 9.997-5.52 0-9.996-4.476-9.996-9.996 0-5.521 4.475-9.996 9.996-9.996 5.52 0 9.996 4.475 9.996 9.996ZM8.988 10.552a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm8.996-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-9.878 3.825a.75.75 0 1 0-1.48.248 6.45 6.45 0 0 0 12.718 0 .75.75 0 0 0-1.479-.248 4.95 4.95 0 0 1-9.759 0Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "smile_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h23.984v23.984H0z",
    transform: "translate(.992 .556)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSmile);
export default ForwardRef;